import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Brasao from '../../assets/images/brasao.png';
import WiFi from '../../assets/images/WiFi.png';
import WiFi2 from '../../assets/images/BrasaoWifi.png';
import './styles.css';

const Nav = () => {
  const [topic, setTopic] = useState('geral'); // padrão
  const [error, setError] = useState('');
  const apiUrl = 'https://automacao.gigabytetelecom.com.br:3009';

  useEffect(() => {
    // Detecta o tópico na URL
    const path = window.location.pathname;
    const segments = path.split('/');
    if (segments.length > 1 && segments[1]) {
      const normalized = segments[1]
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .toLowerCase();
      setTopic(normalized);
    } else {
      setTopic('geral');
    }
  }, []);

  const fetchLeaderboard = async () => {
    try {
      const url =
        topic !== 'geral'
          ? `${apiUrl}/leaderboard?quizTopic=${encodeURIComponent(topic)}`
          : `${apiUrl}/leaderboard`;
      await axios.get(url);
    } catch (err) {
      console.error('Erro ao buscar leaderboard:', err);
      setError('Erro ao carregar dados.');
    }
  };

  useEffect(() => {
    fetchLeaderboard();
    const intervalId = setInterval(fetchLeaderboard, 5000);
    return () => clearInterval(intervalId);
  }, [topic]);

  const isSeguranca = topic === 'seguranca';

  return (
    <div className="title-container">
      <h1>
        <img src={isSeguranca ? Brasao : WiFi2} alt="brasao" />
        {` Quiz - ${isSeguranca ? 'Segurança da Informação' : 'Noções de Redes Wi-Fi'}`}
      </h1>
      {error && <div className="error">{error}</div>}
    </div>
  );
};

export default Nav;
